<div class="table-container">
    <ul>
        <table class="table2">
            <thead>
                <th class="centro-align">
                    <div class="div-flex" *ngIf="itemsFiltrados">
                        <div class="sub-header left">
                            <!-- Input fields to select the date range -->
                            <input type="date" [(ngModel)]="startDateFilter" class="select-input">
                            <input type="date" [(ngModel)]="endDateFilter" class="select-input">
                            <!-- Button to trigger the filter -->
                            <button (click)="applyFilter()" class="select-input">Aplicar Filtro</button>
                        </div>
                        <!-- <div class="sub-header div-margin-left">
                            <button [disabled]="isCarrierJSLEnabled" (click)="milkRunSPFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': milkRunSP}">Milk
                                Run SP</button>
                            <button [disabled]="isCarrierTCMEnabled" (click)="milkRunSulFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': milkRunSul}">Milk
                                Run Sul</button>
                            <button [disabled]="isCarrierJSLARGEnabled" (click)="milkRunArgFilter()"
                                class="select-input" [ngClass]="{'botaoMRSP': milkRunArg}">Milk
                                Run Arg</button>
                        </div> -->
                        <div class="sub-header right">
                            <div class="icone-setting">
                                <!-- <i-feather name="printer"></i-feather> -->
                                <button class="btn-frete icone-setting" mat-button (click)="exportExcel()"><i-feather
                                        name="printer"></i-feather>Print</button>
                            </div>
                            <!-- <button class="btn-frete" mat-button (click)="exportExcel()">
                                <span class="material-icons">print</span> Print
                            </button> -->
                        </div>
                    </div>
                </th>

                <!-- <th class="centro-align">Total de viagens: {{ itemsFiltrados.length }}</th> -->

            </thead>
        </table>

        <!-- <div *ngIf="itemsFiltrados">
            <table style="width: 100%;" class="table2">
                <tr class="table2">
                    <td style="width: 20%;" class="table2"><strong>Filling Rate: </strong>{{ calcularMediaMaiorValor() |
                        number:
                        '1.2-2'
                        }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Porcentagem de Veículos Pequenos:</strong> {{ calcularPorcentagemVeiculosPequenos() |
                        number:
                        '1.2-2' }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Porcentagem de Veículos Médios:</strong> {{ calcularPorcentagemVeiculosMedios() |
                        number: '1.2-2'
                        }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Porcentagem de Veículos Grandes:</strong> {{ calcularPorcentagemVeiculosGrandes() |
                        number: '1.2-2'
                        }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Custo Total:</strong> {{ calcularSomaCustoViagem() | currency:'BRL' }}
                    </td>


                </tr>
            </table>

        </div> -->
        <!-- 
        <div *ngIf="itemsFiltrados">
            <table style="width: 100%;" class="table2">
                <tr class="table2">
                    <td style="width: 20%;" class="table2"><strong>Cumprimento de Janelas: </strong>{{
                        (valorUmTotal / totalItensValidos) * 100
                        | number: '1.2-2' }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Distância Total:</strong> {{ somaTotalDistance | number: '1.2-2' }}Km
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Peso Total:</strong> {{ somaWeightLoaded | number: '1.2-2' }}Ton
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Emissão CO2:</strong> {{ emissao |
                        number: '1.2-2' }}KgCO2/Ton
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Eficiência de Transporte:</strong> {{ getPercentComentNotEmpty() | number: '1.2-2' }}%
                    </td>




                </tr>
            </table>

        </div> -->

        <div class="table2">
            <table id="relatorio-table">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Percurso</th>
                        <th>Viagem</th>
                        <th>pesototal MU</th>
                        <th>pesototal Master Label</th>
                        <th>Peso</th>
                        <th>Placa Carreta</th>
                        <th>Local entrega</th>
                        <th>Comentário</th>
                        <th>Deletar</th>
                    </tr>
                </thead>
                <!-- <tbody *ngFor="let item of itemsFiltrados"> -->
                <tbody *ngFor="let item of percursoArray">
                    <tr [ngClass]="{ 'black-row': $even, 'grafiti-row': $odd }">
                        <td>
                            {{ item.dataPainel }}
                        </td>
                        <!-- <td [class.background-red]="!valorExisteNoModelo(item['Transport Type'])"
                            (click)="veiculoDialog(item)">
                            {{ item['Transport Type'] }}
                        </td> -->
                        <td [ngClass]="{ 'background-red': !isValorValido(item.percurso) }"
                            (click)="editPlaca(item, 'Plate')">
                            {{ isValorValido(item.percurso) ? (item.percurso ) : '' }}
                        </td>



                        <td [ngClass]="{ 'background-red': !isValorValido(item.observacao) }"
                            (click)="editField(item, 'Volumes')">
                            {{ isValorValido(item.observacao) ? (item.observacao ) : '' }}
                        </td>
                        <td [ngClass]="{ 'background-red': !isValorValido(item.pesoPorMU) }"
                            (click)="editField(item, 'Cubage')">
                            {{ (isValorValido(item.pesoPorMU) ? (item.pesoPorMU | number: '1.2-2': 'pt') : '') }}
                        </td>
                        <td [ngClass]="{ 'background-red': !isValorValido(item.pesoTotalML) }"
                            (click)="editField(item, 'Weight Loaded')">
                            {{ isValorValido(item.pesoTotalML) ? (item.pesoTotalML | number: '1.2-2': 'pt') : '' }}
                        </td>

                        <td [ngClass]="{ 'background-red': !isValorValido(item.pesoViagem) }"
                            (click)="editField(item, 'Weight Loaded')">
                            {{ isValorValido(item.pesoViagem) ? (item.pesoViagem | number: '1.2-2': 'pt') : '' }}
                        </td>

                        <!-- <ng-container *ngIf="findVeiculoByModelo(item['Transport Type']) as veiculo">
                            <td [ngClass]="{ 'background-red': !isValorValido(calcularMaiorValor(item, veiculo)) }">
                                {{ calcularMaiorValor(item, veiculo) ? (calcularMaiorValor(item, veiculo) | number:
                                '1.2-2': 'pt') : '' }}
                            </td>
                        </ng-container> -->

                        <td [ngClass]="{ 'background-red': !isValorValido(item.placa) }"
                            (click)="editField(item, 'Total Distance')">
                            {{ isValorValido(item.placa) ? item.placa : '' }}
                        </td>

                        <td [ngClass]="{ 'background-red': !isValorValido(item.tipoAbastecimento) }"
                            (click)="editField(item, 'Total Cost')">
                            {{ isValorValido(item.tipoAbastecimento) ? item.tipoAbastecimento : ''
                            }}
                        </td>
                        <td>
                            <i-feather name="message-circle" (click)="InsereComent(item, 'Coment')"></i-feather>
                        </td>

                        <td>

                            <i-feather name="delete" (click)="deleteItem(item, urlConsulta, query)"
                                class="button-spacing"></i-feather>


                        </td>
                    </tr>
                    <!-- ... Your other table rows ... -->


                </tbody>
            </table>
        </div>

    </ul>

</div>

<!-- <clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h2 class="modal-title">Adicionar Fornecedor</h2>
    <div class="modal-body">
        <form class="inputs">
            <div>
                <label class="modal-label">Fornecedor</label>
                <input type="string" name="fornecedor" [(ngModel)]="item.local" class="modal-input1">
            </div>
            <div>
                <label class="modal-label">e-mail</label>
                <input type="string" name="email" [(ngModel)]="item.contato" class="modal-input2">
            </div>
            <div>
                <label class="modal-label">Endereço</label>
                <input type="string" name="endereco" [(ngModel)]="item.endereco" class="modal-input3">
            </div>
            <div>
                <label class="modal-label">Latitude</label>
                <input type="string" name="latitude" [(ngModel)]="item.latitude" class="modal-input4">
                <label class="modal-label">Longitude</label>
                <input type="string" name="logitude" [(ngModel)]="item.longitude" class="modal-input4">
            </div>

            <div>
                <label class="modal-label">Local de Descarga?</label>
                <input type="checkbox" id="descarga" name="descarga" [(ngModel)]="item.descarga">
            </div>

            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal> -->

<clr-modal [(clrModalOpen)]="dialogTiposOpen" [clrModalSize]="'md'" class="dialog-container">
    <h2 class="modal-title">Cadastrar Tipo de Veículo</h2>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000" style="width: 100%;">
                <tr>
                    <td style="width: 20%;">
                        <label class="modal-label">Modelo</label>
                    </td>
                    <td style="width: 80%;">
                        <input type="string" name="modelo" [(ngModel)]="item.modelo" class="modal-input1">
                    </td>
                </tr>
            </table>
            <table class="table2000" style="width: 100%;">
                <tr>
                    <td style="width: 20%;">
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td style="width: 80%;">
                        <select id="transportadora" name="transportadora" [(ngModel)]="item.transportadora"
                            class="modal-select">
                            <option *ngFor="let transportadora of carrier" [value]="transportadora.name">{{
                                transportadora.name }}
                            </option>
                        </select>
                    </td>
                </tr>
            </table>

            <table class="table2000" style="width: 100%;">
                <tr>
                    <td style="width: 20%;">
                        <label class="modal-label">Perfil</label>
                    </td>
                    <td style="width: 80%;">

                        <select id="perfil" name="perfil" [(ngModel)]="item.perfil" class="modal-select">
                            <option *ngFor="let perfil of perfilVehicles" [value]="perfil">{{ perfil }}
                            </option>
                        </select>


                    </td>
                </tr>
            </table>
            <table class="table2000" style="width: 100%;">
                <tr>
                    <td style="width: 15%;">
                        <label class="modal-label">Combustivel</label>
                    </td>
                    <td style="width: 35%;">
                        <select id="combustivel" name="perfil" [(ngModel)]="item.combustivel" class="modal-select1">
                            <option *ngFor="let combustivel of combustiveis" [value]="combustivel">{{ combustivel }}
                            </option>
                        </select>
                    </td>

                    <td style="width: 35%;">
                        <label class="modal-label">Emissões</label>
                    </td>
                    <td style="width: 15%;">
                        <input type="string" name="emissoes" [(ngModel)]="item.emissoes" class="modal-input4">
                    </td>
                </tr>
            </table>
            <table class="table2000" style="width: 100%;">
                <tr>
                    <button class="modal-button" type="button" (click)="salvarVeiculo()">Save</button>
                    <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
                </tr>

            </table>
        </form>
    </div>
</clr-modal>

<div *ngIf="!itemsFiltrados || isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>